import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { clmJobsApiRef, ClmJobsApiClient } from './api/ClmJobsApi';

export const clmJobsDashboardPlugin = createPlugin({
  id: 'clm-jobs-dashboard',
  apis: [
    createApiFactory({
      api: clmJobsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ClmJobsApiClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const ClmJobsDashboardPage = clmJobsDashboardPlugin.provide(
  createRoutableExtension({
    name: 'ClmJobsDashboardPage',
    component: () => import('./components/App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
